const isReallyDm = ({ firebase: { profile } }) => {
    return profile.email === "bboisvert@gmail.com";
};

export default isReallyDm;



// WEBPACK FOOTER //
// ./src/selectors/isReallyDm.js